<template>
  <div class="scroll-container" :id="name">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "scrollTo",
    props: {
      name: String,
      delayTime: String
    },
    data() {
      return {}
    },
    mounted() {
      this.mainScroll()
      document.addEventListener('scroll', this.mainScroll)
    },
    methods: {
      mainScroll() {
        let offset = 100
        let ele = document.getElementById(this.name)
        let eleTop = ele.getBoundingClientRect().top
        let eleHight = document.documentElement.clientHeight
        let eleClientHeight = ele.clientHeight
        if (eleTop < eleHight - offset) {
          ele.style.top = '0'
          ele.style.opacity = 1
          if (this.delayTime) {
            ele.style.transitionDelay = this.delayTime
          }
        }
        if (eleTop > eleHight || -eleTop > eleClientHeight) {
          ele.style.top = '40px'
          ele.style.opacity = 0
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.scroll-container {
  position: relative;
  top: 40px;
  opacity: 0;
  transition: top linear 0.4s, opacity linear 0.4s;
}
</style>
